exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".visualization-color-chart[data-v-5595c750]{position:absolute;top:0;right:160px;z-index:100;box-sizing:border-box;padding:3px;height:70px;width:367px;border-radius:7px;background:hsla(0,0%,100%,.6);font-size:18px;line-height:1}.visualization-color-chart[data-v-5595c750] .color-chart{margin-top:9px;margin-bottom:4px;padding-left:.5em;padding-right:.5em;height:14px}.visualization-color-chart[data-v-5595c750] .color-chart-text{justify-content:space-between}.visualization-color-chart[data-v-5595c750] .color-chart-text ons-col{flex:0;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5595c750","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/map/visualization/color_chart/frame.vue
// module id = 806
// module chunks = 0